const menuOpened = new Event('menu-opened');

// Document click listener
document.addEventListener('click', (event) => {
    // Toggle Menu Button
    if (event.target.matches('.js-menu-toggle')) {
        document.body.classList.toggle('menu-open');
        if (document.body.classList.contains('menu-open')) {
            document.dispatchEvent(menuOpened);
            document.body.classList.add('noscroll');
        } else {
            document.body.classList.remove('noscroll');
        }
    }
    // Site search Toggle Button
    else if (event.target.matches('.js-search-toggle')) {
        document.body.classList.toggle('search-active');
    }
    // Mini cart Toggle and Close Buttons
    else if (event.target.matches('.js-cart-toggle')) {
        document.body.classList.toggle('mini-cart-active');
    }
    else if (event.target.matches('.js-cart-close')) {
        document.body.classList.remove('mini-cart-active');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const headerScrollHandler = () => {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const offset = windowHeight * 0.2;
    
    let ticking = false;
    if (!ticking) {
        window.requestAnimationFrame(() => {
            if (window.scrollY > offset) {
                document.body.classList.add('sticky-visible');
            } else {
                document.body.classList.remove('sticky-visible');
            }
            ticking = false;
        });
    }
    ticking = true;
    };
    window.addEventListener('DOMContentLoaded', headerScrollHandler, { passive: true });
    window.addEventListener('scroll', headerScrollHandler, { passive: true });
    // Init menu double tap to activate link
    //menuDoubleTapToGo();
});